import { render, staticRenderFns } from "./RewardForm.vue?vue&type=template&id=157340d2&scoped=true"
import script from "./RewardForm.vue?vue&type=script&lang=js"
export * from "./RewardForm.vue?vue&type=script&lang=js"
import style0 from "./RewardForm.vue?vue&type=style&index=0&id=157340d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157340d2",
  null
  
)

export default component.exports